import { computed, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useAuthStore } from '@/stores'
import { workspacesApi } from '@/api/endpoints/workspaces'

const noop = /** @type {() => boolean} */ (() => true)

/**
 * The global workspace list. Only super admins have one (everyone else's workspaces come with their
 * profile), so it is disabled for them. Store mutations call `invalidateList('workspaces')`.
 *
 * @param {object | import('vue').Ref | (() => object)} [params] `{ page, per_page, search }`
 * @param {{ enabled?: () => boolean }} [options]
 */
export function useAdminWorkspaces(params = {}, { enabled = noop } = {}) {
  const authStore = useAuthStore()
  const query = useQuery({
    queryKey: () => ['workspaces', 'list', { ...toValue(params) }],
    queryFn: ({ signal }) => workspacesApi.list({ ...toValue(params) }, { signal }),
    select: (body) => body.data,
    enabled: () => authStore.isSuperAdmin && enabled(),
    placeholderData: (previous) => previous,
  })
  return {
    ...query,
    workspaces: computed(() => query.data.value?.workspaces ?? []),
    pagination: computed(() => query.data.value?.pagination ?? {}),
    metrics: computed(() => query.data.value?.metrics ?? null),
  }
}
